<template>
  <div class="commissions-page">
    <div class="page-header">
      <h2>💰 مدیریت کمسیون سالن‌ها</h2>
      <p class="subtitle">تنظیم درصد کمسیون اختصاصی هر سالن</p>
    </div>

    <!-- ========================================== -->
    <!-- فیلترها -->
    <!-- ========================================== -->
    <div class="filter-section">
      <div class="filter-row">
        <div class="filter-group">
          <label>جستجو</label>
          <input
              v-model="filters.search"
              type="text"
              placeholder="نام سالن..."
              class="filter-input"
              @keyup.enter="loadData"
          />
        </div>
        <button class="btn-search" @click="loadData">🔍 جستجو</button>
        <button class="btn-reset" @click="resetFilters">⟳ پاک کردن</button>
      </div>
    </div>

    <!-- ========================================== -->
    <!-- لیست سالن‌ها -->
    <!-- ========================================== -->
    <div v-if="loading" class="loading-state">
      <div class="spinner"></div>
      <span>در حال بارگذاری...</span>
    </div>

    <div v-else-if="items.length === 0" class="empty-state">
      <div class="empty-icon">📭</div>
      <h3>هیچ سالنی یافت نشد</h3>
    </div>

    <div v-else>
      <!-- ===== دسکتاپ: جدول ===== -->
      <div class="desktop-table">
        <table>
          <thead>
          <tr>
            <th>#</th>
            <th>نام سالن</th>
            <th>کد سالن</th>
            <th>درصد کمسیون</th>
            <th>وضعیت</th>
            <th>عملیات</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in items" :key="item.id">
            <td>{{ index + 1 }}</td>
            <td class="market-name">{{ item.title }}</td>
            <td class="market-code">{{ item.market_code }}</td>
            <td>
              <div class="commission-display">
                <span class="commission-value">{{ item.commission_percent }}%</span>
              </div>
            </td>
            <td>
                <span :class="['badge', item.is_active ? 'badge-success' : 'badge-danger']">
                  {{ item.is_active ? 'فعال' : 'غیرفعال' }}
                </span>
            </td>
            <td>
              <button class="btn-edit" @click="openEditModal(item)">
                ✏️ ویرایش
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <!-- ===== موبایل: کارت ===== -->
      <div class="mobile-cards">
        <div v-for="(item, index) in items" :key="item.id" class="card-item">
          <div class="card-header">
            <span class="card-index">#{{ index + 1 }}</span>
            <span :class="['badge', item.is_active ? 'badge-success' : 'badge-danger']">
              {{ item.is_active ? 'فعال' : 'غیرفعال' }}
            </span>
          </div>
          <div class="card-body">
            <div class="card-row">
              <span class="card-label">سالن:</span>
              <span>{{ item.title }}</span>
            </div>
            <div class="card-row">
              <span class="card-label">کد:</span>
              <span class="market-code">{{ item.market_code }}</span>
            </div>
            <div class="card-row">
              <span class="card-label">کمسیون:</span>
              <span class="commission-value">{{ item.commission_percent }}%</span>
            </div>
          </div>
          <div class="card-actions">
            <button class="btn-edit" @click="openEditModal(item)">✏️ ویرایش</button>
          </div>
        </div>
      </div>
    </div>

    <!-- ========================================== -->
    <!-- مودال ویرایش کمسیون -->
    <!-- ========================================== -->
    <div v-if="showEditModal" class="modal-overlay" @click.self="closeEditModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>✏️ ویرایش کمسیون</h3>
          <button class="btn-close" @click="closeEditModal">✕</button>
        </div>
        <div class="modal-body">
          <p class="modal-info">
            سالن: <strong>{{ selectedItem ? selectedItem.title : '' }}</strong>
          </p>
          <div class="form-group">
            <label class="required">درصد کمسیون</label>
            <div class="input-with-suffix">
              <input
                  v-model.number="commissionPercent"
                  type="number"
                  min="0"
                  max="100"
                  step="0.1"
                  class="form-control"
                  placeholder="مثلاً 2"
              />
              <span class="suffix">%</span>
            </div>
            <small class="help-text">مقدار بین ۰ تا ۱۰۰ درصد</small>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-secondary" @click="closeEditModal">انصراف</button>
          <button
              class="btn-primary"
              @click="submitEdit"
              :disabled="submitting || commissionPercent === null"
          >
            {{ submitting ? '⏳ در حال ذخیره...' : '💾 ذخیره' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CommissionsPage',

  data: function() {
    return {
      loading: false,
      submitting: false,
      items: [],
      filters: {
        search: ''
      },
      showEditModal: false,
      selectedItem: null,
      commissionPercent: null
    };
  },

  mounted: function() {
    this.loadData();
  },

  methods: {
    // ==========================================
    // بارگذاری داده‌ها
    // ==========================================
    loadData: async function() {
      this.loading = true;
      try {
        var params = {};
        if (this.filters.search) params.search = this.filters.search;

        var response = await axios.get('/api/super-admin/market-commissions', { params: params });
        this.items = response.data.data || [];

      } catch (error) {
        console.error('خطا:', error);
        if (this.$message) {
          this.$message.error('خطا در بارگذاری اطلاعات');
        } else {
          alert('خطا در بارگذاری اطلاعات');
        }
      } finally {
        this.loading = false;
      }
    },

    // ==========================================
    // باز کردن مودال ویرایش
    // ==========================================
    openEditModal: function(item) {
      this.selectedItem = item;
      this.commissionPercent = parseFloat(item.commission_percent);
      this.showEditModal = true;
    },

    closeEditModal: function() {
      this.showEditModal = false;
      this.selectedItem = null;
      this.commissionPercent = null;
    },

    // ==========================================
    // ارسال ویرایش
    // ==========================================
    submitEdit: async function() {
      if (this.commissionPercent === null || this.commissionPercent < 0 || this.commissionPercent > 100) {
        if (this.$message) {
          this.$message.warning('درصد کمسیون باید بین ۰ تا ۱۰۰ باشد.');
        } else {
          alert('درصد کمسیون باید بین ۰ تا ۱۰۰ باشد.');
        }
        return;
      }

      this.submitting = true;
      try {
        await axios.put('/api/super-admin/market-commission/' + this.selectedItem.id, {
          commission_percent: this.commissionPercent
        });

        if (this.$message) {
          this.$message.success('کمسیون با موفقیت بروزرسانی شد.');
        } else {
          alert('کمسیون با موفقیت بروزرسانی شد.');
        }

        this.closeEditModal();
        this.loadData();

      } catch (error) {
        var errorMsg = 'خطا در ذخیره';
        if (error.response && error.response.data && error.response.data.message) {
          errorMsg = error.response.data.message;
        }
        if (this.$message) {
          this.$message.error(errorMsg);
        } else {
          alert(errorMsg);
        }
      } finally {
        this.submitting = false;
      }
    },

    // ==========================================
    // ریست فیلترها
    // ==========================================
    resetFilters: function() {
      this.filters = { search: '' };
      this.loadData();
    }
  }
};
</script>

<style scoped>
/* ========================================== */
/* استایل‌های اصلی */
/* ========================================== */
.commissions-page {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  direction: rtl;
}

.page-header {
  margin-bottom: 24px;
}

.page-header h2 {
  margin: 0;
  color: #2c3e50;
  font-size: 24px;
}

.page-header .subtitle {
  margin: 4px 0 0 0;
  color: #909399;
  font-size: 14px;
}

/* ========================================== */
/* فیلترها */
/* ========================================== */
.filter-section {
  background: white;
  padding: 16px 20px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 20px;
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
}

.filter-group label {
  font-size: 13px;
  color: #606266;
  font-weight: 500;
}

.filter-input {
  padding: 6px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  font-size: 13px;
  background: white;
  min-width: 200px;
}

.filter-input:focus {
  outline: none;
  border-color: #409eff;
}

.btn-search {
  padding: 6px 20px;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
}

.btn-search:hover {
  background: #66b1ff;
}

.btn-reset {
  padding: 6px 16px;
  background: #f5f7fa;
  color: #606266;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
}

.btn-reset:hover {
  background: #e4e7ed;
}

/* ========================================== */
/* حالت بارگذاری و خالی */
/* ========================================== */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  color: #909399;
  gap: 12px;
  background: white;
  border-radius: 10px;
}

.spinner {
  width: 36px;
  height: 36px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #409eff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 10px;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 12px;
}

.empty-state h3 {
  color: #2c3e50;
}

/* ========================================== */
/* جدول */
/* ========================================== */
.desktop-table {
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  overflow-x: auto;
}

.desktop-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  min-width: 700px;
}

.desktop-table thead th {
  background: #f5f7fa;
  color: #606266;
  font-weight: 600;
  padding: 12px 14px;
  text-align: right;
  border-bottom: 2px solid #e4e7ed;
}

.desktop-table tbody td {
  padding: 10px 14px;
  border-bottom: 1px solid #ebeef5;
  color: #303133;
  vertical-align: middle;
}

.desktop-table tbody tr:hover td {
  background: #f5f7fa;
}

.market-name {
  font-weight: 500;
}

.market-code {
  font-family: monospace;
  font-size: 12px;
  color: #909399;
}

/* ========================================== */
/* نمایش کمسیون */
/* ========================================== */
.commission-display {
  display: inline-block;
}

.commission-value {
  display: inline-block;
  padding: 4px 12px;
  background: #ecf5ff;
  color: #409eff;
  border-radius: 12px;
  font-weight: 600;
  font-size: 13px;
}

/* ========================================== */
/* بج‌ها */
/* ========================================== */
.badge {
  display: inline-block;
  padding: 2px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
}

.badge-success {
  background: #f0f9eb;
  color: #67c23a;
}

.badge-danger {
  background: #fef0f0;
  color: #f56c6c;
}

/* ========================================== */
/* دکمه‌ها */
/* ========================================== */
.btn-edit {
  padding: 4px 14px;
  background: #ecf5ff;
  color: #409eff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s;
}

.btn-edit:hover {
  background: #409eff;
  color: white;
}

/* ========================================== */
/* کارت‌های موبایل */
/* ========================================== */
.mobile-cards {
  display: none;
}

.card-item {
  background: white;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.card-index {
  font-weight: 600;
  color: #909399;
  font-size: 13px;
}

.card-body {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.card-row {
  display: flex;
  gap: 6px;
  font-size: 13px;
  color: #303133;
  flex-wrap: wrap;
}

.card-label {
  font-weight: 500;
  color: #909399;
  min-width: 60px;
}

.card-actions {
  display: flex;
  gap: 8px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
}

.card-actions .btn-edit {
  flex: 1;
  padding: 8px;
  text-align: center;
}

/* ========================================== */
/* مودال */
/* ========================================== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal-content {
  background: white;
  border-radius: 12px;
  max-width: 450px;
  width: 92%;
  animation: slideUp 0.3s;
}

@keyframes slideUp {
  from { transform: translateY(30px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.modal-header h3 {
  margin: 0;
  color: #2c3e50;
}

.btn-close {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: #909399;
}

.btn-close:hover {
  color: #2c3e50;
}

.modal-body {
  padding: 20px;
}

.modal-info {
  margin-bottom: 16px;
  color: #606266;
}

.modal-info strong {
  color: #2c3e50;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  font-weight: 600;
  font-size: 14px;
  color: #2c3e50;
  margin-bottom: 6px;
}

.form-group label.required::after {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}

.input-with-suffix {
  display: flex;
  align-items: center;
  gap: 6px;
}

.form-control {
  flex: 1;
  padding: 10px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-control:focus {
  outline: none;
  border-color: #409eff;
}

.suffix {
  color: #606266;
  font-weight: 600;
}

.help-text {
  color: #909399;
  font-size: 12px;
  margin-top: 4px;
  display: block;
}

.modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.btn-primary {
  padding: 8px 24px;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.btn-primary:hover:not(:disabled) {
  background: #66b1ff;
}

.btn-primary:disabled {
  background: #a0cfff;
  cursor: not-allowed;
}

.btn-secondary {
  padding: 8px 24px;
  background: #909399;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.btn-secondary:hover {
  background: #a6a9ad;
}

/* ========================================== */
/* ریسپانسیو */
/* ========================================== */
@media (max-width: 768px) {
  .commissions-page {
    padding: 12px;
  }

  .filter-row {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-group {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-input {
    width: 100%;
    min-width: unset;
  }

  .btn-search,
  .btn-reset {
    width: 100%;
    text-align: center;
  }

  .desktop-table {
    display: none;
  }

  .mobile-cards {
    display: block;
  }

  .modal-content {
    width: 95%;
  }
}

@media (max-width: 480px) {
  .commissions-page {
    padding: 8px;
  }

  .page-header h2 {
    font-size: 20px;
  }
}
</style>